import { useEffect, useState } from 'react';
import { apiFetch } from './apiClient';

export const getBillingCurrency = () => {
  const query = new URLSearchParams(window.location.search).get('currency');
  if (['gbp', 'eur'].includes(query)) return query;
  try { return localStorage.getItem('noteician.billing_currency') === 'eur' ? 'eur' : 'gbp'; }
  catch (_) { return 'gbp'; }
};
export const saveBillingCurrency = currency => {
  const url = new URL(window.location.href);
  if (url.searchParams.has('currency')) {
    url.searchParams.set('currency', currency);
    window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
  }
  try { localStorage.setItem('noteician.billing_currency', currency); } catch (_) { /* Optional. */ }
};
export function useBillingCatalog(currency, enabled = true) {
  const [state, setState] = useState({ catalog: null, loading: true, failed: false });
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    setState({ catalog: null, loading: true, failed: false });
    apiFetch(`/api/billing/catalog?currency=${currency}`, { signal: controller.signal })
      .then(response => { if (!response.ok) throw new Error(); return response.json(); })
      .then(catalog => {
        if (!catalog || catalog.currency !== currency || !Array.isArray(catalog.prices) || !catalog.prices.every(price => ['individual', 'practice'].includes(price.plan) && ['monthly', 'yearly'].includes(price.interval) && price.currency === currency && Number.isInteger(price.unitAmount) && price.unitAmount >= 0)) throw new Error();
        if (!controller.signal.aborted) setState({ catalog, loading: false, failed: false });
      })
      .catch(() => { if (!controller.signal.aborted) setState({ catalog: null, loading: false, failed: true }); });
    return () => controller.abort();
  }, [currency, enabled]);
  return state;
}
